export enum EventGroupBy {
    LandingPage = 'landing_page', // default
    Campaign = 'campaign'
}